module.exports = __webpack_public_path__ + "static/img/step1.d258a81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/howto/step1.png
// module id = VLo2
// module chunks = 1